import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "María González",
    role: "Cliente · Miami, FL",
    initials: "MG",
    text:
      "Yohaly me ayudó con mis impuestos y con el ITIN de mi esposo. Todo fue rápido, claro y sin sorpresas. Explica con paciencia y se nota que sabe. La recomiendo 100%.",
    rating: 5,
  },
  {
    name: "Carlos Rodríguez",
    role: "Propietario LLC · Doral, FL",
    initials: "CR",
    text:
      "Abrí mi LLC con Great Solutions US y quedé muy satisfecho. Me guiaron paso a paso, me ayudaron con el EIN y la contabilidad mensual. Servicio profesional y humano.",
    rating: 5,
  },
  {
    name: "Ana Martínez",
    role: "Cliente · Hialeah, FL",
    initials: "AM",
    text:
      "Necesitaba notarizar unos documentos urgentes y me atendieron el mismo día. Excelente trato, muy profesionales. También me ayudaron con un seguro de vida para mi familia.",
    rating: 5,
  },
  {
    name: "Luis Herrera",
    role: "Emprendedor · Kendall, FL",
    initials: "LH",
    text:
      "Llevo dos años trabajando con Yohaly para mis impuestos personales y de mi pequeño negocio. Es la primera vez que entiendo lo que pago y por qué. Servicio de primera.",
    rating: 5,
  },
  {
    name: "Diana Pérez",
    role: "Cliente · Coral Gables, FL",
    initials: "DP",
    text:
      "Me ayudaron con formularios migratorios muy complicados. Todo fue explicado con detalle. Se toman su tiempo con cada cliente. Muy agradecida por el acompañamiento.",
    rating: 5,
  },
  {
    name: "Roberto Silva",
    role: "Dueño de negocio · Homestead, FL",
    initials: "RS",
    text:
      "Excelente contabilidad para mi negocio. Ahora tengo mis números claros mes a mes y sé exactamente cómo va mi empresa. Yohaly es honesta y muy profesional.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section id="testimonios" className="py-24 lg:py-32 bg-[#f8fafc]" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Testimonios reales
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            La confianza de{" "}
            <span className="text-[#0B2D5C]">nuestros clientes</span> es nuestro mayor logro.
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed">
            Familias, emprendedores y pequeños negocios comparten su experiencia con Great Solutions US.
          </p>

          <div className="mt-6 flex items-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="text-[#C89B2C] fill-[#C89B2C]" size={20} />
              ))}
            </div>
            <span className="font-semibold text-[#0f172a]">5.0</span>
            <span className="text-sm text-[#475569]">basado en reseñas de Google</span>
          </div>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              className="reveal bg-white border border-[#e2e8f0] p-7 rounded-sm hover:border-[#C89B2C] hover:-translate-y-1 transition-all duration-300 relative"
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`testimonial-${i}`}
            >
              <Quote className="absolute top-6 right-6 text-[#e2e8f0]" size={32} strokeWidth={1.5} />

              <div className="flex mb-4">
                {[...Array(t.rating)].map((_, j) => (
                  <Star key={j} className="text-[#C89B2C] fill-[#C89B2C]" size={16} />
                ))}
              </div>

              <p className="text-[15px] text-[#334155] leading-relaxed mb-6">"{t.text}"</p>

              <div className="flex items-center gap-3 pt-5 border-t border-[#e2e8f0]">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#0B2D5C] to-[#050F26] text-white flex items-center justify-center font-semibold text-sm">
                  {t.initials}
                </div>
                <div>
                  <div className="font-semibold text-[#0f172a] text-sm">{t.name}</div>
                  <div className="text-xs text-[#475569]">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
